import { Box, Typography, styled } from "@mui/material";

const CategoryContainer = styled(Box)({
  marginBottom: 2,
  display: "flex",
  flexDirection: "column",
});

const CategoryTitle = styled(Typography)(({ theme }) => ({
  fontSize: 9.5,
  fontWeight: 700,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: theme.palette.neutral[400],
  padding: "10px 6px 4px",
  margin: 0,
  whiteSpace: "nowrap",
}));

const CategoryItems = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 1,
});

// eslint-disable-next-line no-unused-vars
const SideNavCategory = ({ title, children, isMiniNav, defaultOpen }) => {
  return (
    <CategoryContainer>
      <CategoryTitle>{title}</CategoryTitle>
      <CategoryItems>{children}</CategoryItems>
    </CategoryContainer>
  );
};

export default SideNavCategory;
